import { ReactElement, useEffect } from "react"
import { Paper, Box } from "@material-ui/core";
import { useLocation, useParams } from "react-router";
import useAxios from "axios-hooks";
import { CustomerProfile } from '../../../app/components/customer/profile/customer-profile.types';
import { HttpError } from "tools/HttpTypes";
import ProfilePicture from '../../../style/icons/icon-profile.svg';
import { NxButtonLink, NxButtonVariant } from "@nextbank/ui-components";
import commandAccessService from "command/commandAccessService";

const CustomerDetails = (): ReactElement => {
    const url = useLocation();
    const showCustomerDetails = url.pathname.includes('cocree');
    const { customerId } = useParams<{ customerId: string }>();
    const isExposurePage = url.pathname.includes('exposure');
    const isNegativePage = url.pathname.includes('negative-information');
    const [{ data: customerData, loading }, fetchCustomerData] = useAxios<CustomerProfile, HttpError>(
        `/customers/${customerId}`, {
            manual: true
        }
    );
    const hasCreateExposureAccess = commandAccessService.canExecute("CreateExposure");
    const hasCreateNegativeEventAccess = commandAccessService.canExecute("CreateNegativeEvent");

    useEffect(() => {
        if (showCustomerDetails) {
            fetchCustomerData()
        }
    }, [])

    return (
        <>
            {showCustomerDetails && !loading ? <>
                <Paper elevation={1}>
                    <Box p={3} mb={2} pl={1.5}>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                        }}>
                            <ProfilePicture />
                            <div style={{
                                marginLeft: "2.5rem",
                                marginRight: "30rem"
                            }}>
                                <span style={{
                                    color: "gray",
                                    fontSize: "12px"
                                }}>Name:</span>
                                <div style={{
                                    fontSize: "12px"
                                }}>
                                    {customerData?.individualData ?  `${customerData?.effectiveName}`: customerData?.corporateData?.businessName}
                                </div>
                            </div>

                            <div>
                                <span style={{
                                    color: "gray",
                                    fontSize: "12px"
                                }}>CIF:</span>
                                <div style={{
                                    fontSize: "12px"
                                }}>
                                    {customerData?.customerNumber}
                                </div>
                            </div>

                            {isExposurePage && hasCreateExposureAccess ? <div style={{
                                marginLeft: "auto"
                            }}>
                                <NxButtonLink disabled={url.pathname.includes('exposure/new')} variant={NxButtonVariant.CONTAINED} to={`/customer/${customerId}/cocree/exposure/new`}>Add new exposure</NxButtonLink>
                            </div> : null}

                            {isNegativePage && hasCreateNegativeEventAccess ? <div style={{
                                marginLeft: "auto"
                            }}>
                                <NxButtonLink disabled={url.pathname.includes('negative-information/new')} variant={NxButtonVariant.CONTAINED} to={`/customer/${customerId}/cocree/negative-information/new`}>Add new</NxButtonLink>
                            </div> : null}
                        </div>
                    </Box>
                </Paper>
            </> : null}
        </>
    )
}

export default CustomerDetails;